var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31496 14.8948C4.21839 14.8948 2.52598 16.5872 2.52598 18.6838C2.52598 20.3383 1.06091 21.2098 0 21.2098C1.16195 22.7506 3.14485 23.7358 5.05197 23.7358C7.84318 23.7358 10.1039 21.475 10.1039 18.6838C10.1039 16.5872 8.41152 14.8948 6.31496 14.8948Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6306 3.06182L21.9382 1.36941C21.7022 1.13291 21.3818 1 21.0478 1C20.7137 1 20.3933 1.13291 20.1573 1.36941L8.84094 12.6858L12.3142 16.159L23.6306 4.84263C24.1231 4.35007 24.1231 3.55438 23.6306 3.06182Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.8c8a0acc.svg";
export { ForwardRef as ReactComponent };